import {inject, Injectable}                                                                                     from '@angular/core';
import {FirebasePaths, GlobalRecordGroupDict, MindConfIntf, MindPsycType, MindRecordLogIntf, MindRecordSumIntf} from '@djsharkk/logr-types';
import {BehaviorSubject}                                                                                        from 'rxjs';
import {AuthUnlockService}                                                                                      from '../../../logr-auth/utils/auth-unlock.service';
import {DataFirebaseBase}                                                                                       from './data-firebase.base';

@Injectable({
				providedIn: 'root'
			})
export class DataMindService extends DataFirebaseBase<MindRecordLogIntf, MindRecordSumIntf> {
	svcAuthUnlock = inject(AuthUnlockService)

	protected paths: GlobalRecordGroupDict<FirebasePaths, FirebasePaths | undefined> = {
		log: 'mind_records_log',
		sum: 'mind_records_sum'
	};

	mindConf = new BehaviorSubject<MindConfIntf[]>([]);


	constructor() {
		super();
		this.svcFirebaseTools.recFetch<MindConfIntf>('mind_conf').subscribe(conf => this.mindConf.next(conf))

		this.records.log.subscribe(records => {
			records
				.filter(record => record.note?.length)
				.forEach(record => {
					if (record.note) {
						this.svcAuthUnlock.decrypt(record.note).then(note => record.note = note)
					}

					const psyc = Promise.all(
						record.mind.map(async (mind) => await this.svcAuthUnlock.decrypt(mind) as MindPsycType)
					);

					psyc.then(mind => record.mind = mind)
				})
		})
	}

	createRecord(record: MindRecordLogIntf) {
		this.svcFirebaseTools.recCreate<MindRecordLogIntf>(this.paths.log, record);
	}
}
